import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

type RuleNames =
  | 'chat'
  | 'chatList'
  | 'chatText'
  | 'chatSmallText'
  | 'textBlock'
  | 'chatDate'
  | 'link'
  | 'isHovered'
  | 'chatFocused'
  | 'errorMessage';

const PREFIX = 'ChatList';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      chat: {
        color: '#0B170C',
        padding: '0 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 76,
        marginBottom: 8,
        boxShadow: '0px -2px 20px rgba(11, 23, 12, 0.05)',
        cursor: 'pointer',
        transition: 'background-color 0.1s ease',
        '&:hover': {
          background: '#6CA370',
          color: '#E6F4E7',
        },
      },
      errorMessage: {
        fontSize: '20px',
        fontFamily: theme.caslonDoric,
        color: theme.darkGreen,
        marginTop: '20px',
        textAlign: 'center',
      },
      chatFocused: {
        background: '#6CA370',
        color: '#E6F4E7',
        padding: '0 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 76,
        marginBottom: 8,
        boxShadow: '0px -2px 20px rgba(11, 23, 12, 0.05)',
        cursor: 'pointer',
        transition: 'background-color 0.1s ease',
      },
      isHovered: {
        color: '#E6F4E7',
        fontFamily: theme.helveticaNeue,
        fontSize: '12px',
        fontWeight: 400,
      },
      chatList: {
        width: '43.5%',
        height: '100%',
        overflowY: 'scroll',
        '&:first-child': {
          borderRadius: '10px 0 0 0',
        },
        '&:last-child': {
          borderRadius: '0 0 0 10px',
        },
      },
      chatText: {
        fontFamily: theme.helveticaNeue,
        fontSize: '16px',
        fontWeight: 600,
      },
      chatSmallText: {
        color: '#676767',
        fontFamily: theme.helveticaNeue,
        fontSize: '12px',
        fontWeight: 400,
      },
      textBlock: {
      },
      chatDate: {
        fontFamily: theme.helveticaNeue,
        fontSize: '16px',
        fontWeight: 600,
        width: '28px',
        textAlign: 'center',
        marginRight: 24,
      },
      link: {
        textDecoration: 'none',
      },
    }
  ),
  { name: PREFIX },
);
